import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { encodeData } from "~/utils/utils";
import { queryClient } from "./index";

export const useReportsWidgetData = (widget_group, widget_type, config) => {
  return useQuery({
    ...config,
    queryKey: [`reports-${widget_group}-widgets`, widget_type],
    queryFn: () =>
      fetch({
        url: `${Angie.api_url}/reports/dashboard/widget?widget_group=${widget_group}&widget_type=${widget_type}`,
      }),
  });
};
// assignments
export const useAssignmentsWidgetData = (widget_type, config) => {
  return useReportsWidgetData("assignments", widget_type, config);
};

// invalidate all assignments widgets
export const invalidateAllAssignmentsWidgets = () => {
  queryClient.invalidateQueries(["reports-assignments-widgets"]);
};

// invalidate specific assignment widget
export const invalidateAssignmentsWidgetData = (widget_type) => {
  queryClient.invalidateQueries(["reports-assignments-widgets", widget_type]);
};

export const useCostVsBudgetWidgetData = (queryParams = {}, key, config) => {
  const params = {
    widget_group: "assignments",
    widget_type: "project_overview_widget",
    ...queryParams,
  };
  const url = `${Angie.api_url}/reports/dashboard/widget?${encodeData(params)}`;

  return useQuery({
    ...config,
    queryKey: ["cost-vs-budget", key],
    queryFn: () => fetch({ url }),
  });
};

// invalidate cost vs budget widget
export const invalidateCostVsBudgetWidgetData = () => {
  queryClient.invalidateQueries(["cost-vs-budget"]);
};

//time
export const useTimeWidgetData = (widget_type, from, to, config) => {
  const params = {
    widget_group: "time_tracking",
    widget_type,
    ...(from && { from }),
    ...(to && { to }),
  };
  const url = `${Angie.api_url}/reports/dashboard/widget?${encodeData(params)}`;
  return useQuery({
    ...config,
    queryKey: [`reports-time-tracking-widgets`, widget_type, from, to],
    queryFn: () =>
      fetch({
        url,
      }),
  });
};

// invalidate all time widgets
export const invalidateAllTimeWidgets = () => {
  queryClient.invalidateQueries(["reports-time-tracking-widgets"]);
};

// invalidate specific time widget
export const invalidateTimeWidgetData = (widget_type) => {
  queryClient.invalidateQueries(["reports-time-tracking-widgets", widget_type]);
};
